import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import { FooterDataStructure } from "../../data/FooterData"

export default function Footer() {
  return (
    <>
      <FooterWrapper className="foot__wrapper__resp">
        <FooterContentWrapper>
          <FooterWrapperComponents>
            <FooterLinkWrapper>
              <FooterLinkColumn>
                {FooterDataStructure.map(item => {
                  return (
                    <>
                      <Link to={item.route} style={{ textDecoration: "none" }}>
                        <MenuRowWrapper>
                          <MenuRowContainer>
                            <img
                              src={item.image}
                              style={{ maxWidth: "100%", margin: "auto" }}
                            />
                            <TextStylesCaption>{item.title}</TextStylesCaption>
                          </MenuRowContainer>
                        </MenuRowWrapper>
                      </Link>
                    </>
                  )
                })}
              </FooterLinkColumn>
            </FooterLinkWrapper>
            <FooterCredits>
              <FooterCreditsText>
                Site made with React, Gatsby
              </FooterCreditsText>
              <FooterCreditsTextSecond>
                Veu CSS &copy; 2021
              </FooterCreditsTextSecond>
              <a href="https://github.com/veucss/veu" target="_blank">
                <FooterCreditsTextSecond>
                  Follow <Bold>Github</Bold>
                </FooterCreditsTextSecond>
              </a>
              <a
                href="https://github.com/veucss/veu/blob/main/SECURITY.md"
                target="_blank"
              >
                <FooterCreditsTextSecond>
                  Need help? <Bold>Contact Us</Bold>
                </FooterCreditsTextSecond>
              </a>
            </FooterCredits>
          </FooterWrapperComponents>
        </FooterContentWrapper>
      </FooterWrapper>
    </>
  )
}

const FooterWrapper = styled.div`
  padding-top: 250px;
  height: 640px;
  position: relative;
  width: 100%;
  margin-top: 30rem;
`

const FooterContentWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 640px;
  justify-content: center;
  background: rgb(30, 19, 87);
`

const FooterWrapperComponents = styled.div`
  position: relative;
  max-width: 660px;
  display: grid;
  grid-template-columns: auto auto;
  margin: 0px auto;
  padding: 0px 20px;
  box-sizing: border-box;
`

const FooterLinkWrapper = styled.div`
  display: grid;
  grid-template-columns: 120px 104px;
  gap: 0px;
  max-width: 340px;
`

const FooterLinkColumn = styled.div`
  display: grid;
  row-gap: 20px;
  max-width: 160px;
`

const MenuRowWrapper = styled.div`
  height: 44px;
  transition: all 0.3s ease-in-out 0s;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;

  :hover {
    background: rgba(255, 255, 255, 0.1);
    background-blend-mode: overlay;
    mix-blend-mode: normal;
    box-shadow: rgba(255, 255, 255, 0.2) 0px 0px 0px 0.5px inset;
    box-sizing: border-box;
  }
`

const MenuRowContainer = styled.div`
  display: inline-flex;
`

const TextStylesCaption = styled.p`
  font-style: normal;
  font-size: 15px;
  font-weight: normal;
  line-height: 130%;
  color: white;
  text-align: center;
  margin: auto auto auto 10px;
`

const FooterCredits = styled.div`
  max-width: 280px;
  height: 110px;
  color: rgba(255, 255, 255, 0.7);
  padding: 64px 0px;
  font-size: 13px;
`

const FooterCreditsText = styled.p`
  font-style: normal;
  font-size: 13px;
  line-height: 130%;
  color: rgba(255, 255, 255, 0.7);
  margin: 0px;
  font-weight: normal;
`

const FooterCreditsTextSecond = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 130%;
  color: rgba(255, 255, 255, 0.6);
  margin: 20px 0px;
`

const Bold = styled.span`
  font-style: normal;
  font-weight: bold;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0px;
  text-decoration: none;

  :hover {
    text-decoration-line: underline;
  }
`
